import { render, staticRenderFns } from "./ProductionCosts.vue?vue&type=template&id=0136914a&scoped=true&"
import script from "./ProductionCosts.vue?vue&type=script&lang=js&"
export * from "./ProductionCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136914a",
  null
  
)

export default component.exports